import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <g clipPath="url(#clip0_733_18201)">
        <path
          fill="#D9DFE0"
          d="M9.04.4C4.26.4.4 4.28.4 9.06s3.88 8.64 8.66 8.64a8.63 8.63 0 008.64-8.64C17.7 4.26 13.82.4 9.04.4zm1.1 2.86l-.4 8.24H8.36l-.4-8.24h2.18zm-.2 11.24c-.26.22-.56.34-.9.34-.34 0-.64-.12-.88-.36-.24-.22-.38-.5-.38-.88 0-.36.12-.66.38-.88.22-.22.52-.34.88-.34s.68.12.9.34c.24.24.36.52.36.88s-.12.66-.36.9z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_733_18201">
          <path fill="#fff" d="M0 0H18V18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
